export function formatLibReferenceDirective(libName: string): string {
	return `/// <reference lib="${libName}" />`;
}
